import { Component, Input, OnInit } from "@angular/core";
import { FeedbackType } from "@app/shared/models/feedbackType";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { BlackButtonComponent } from "../black-button/black-button.component";

@Component({
  selector: "app-message-modal",
  standalone: true,
  imports: [BlackButtonComponent],
  templateUrl: "./message-modal.component.html",
  styleUrl: "./message-modal.component.scss",
})
export class MessageModalComponent implements OnInit {
  @Input({ required: true }) type: FeedbackType = FeedbackType.SUCCESS;
  @Input({ required: true }) title: string = "";
  @Input({ required: true }) message: string = "";

  iconsList = ["ic-success", "ic-error", "ic-report"];

  icon: string = "";
  className: string = "";
  public feedbackType = FeedbackType;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.setStyle();
  }

  private setStyle() {
    if (this.type === FeedbackType.SUCCESS) {
      this.icon = "ic-success";
      this.className = "success";
    }
    if (this.type === FeedbackType.ERROR) {
      this.icon = "ic-error";
      this.className = "error";
    }

    if (this.type === FeedbackType.CONFIRMATION) {
      this.icon = "ic-report";
      this.className = "confirmation";
    }

    if (this.type === FeedbackType.INSTRUMENT_TECHNICIAN) {
      this.icon = "ic-success";
      this.className = "success";
    }
  }
}
